import { createAppRequest } from "@/services/request";
import type { ApiRequestOptions } from "./types/common";

const request = createAppRequest();

export interface OpenPlatformTokenResult {
  accessToken: string;
  expiresAt: number;
}

export function getOpenPlatformToken(options?: ApiRequestOptions) {
  return request<OpenPlatformTokenResult>("/bff/open-platform/token", {
    method: "GET",
    ...(options || {}),
  });
}
